import React from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import * as DOMPurify from 'dompurify';
import Axios from 'axios';  
import { useEffect, useState } from 'react'
import { domain } from '../env';

export const BlogMedia = () => {
    const [blog, setBlog] = useState([]);
    const [loading, setLoading] = useState(true);

    const getBlog = async () => {
        setLoading(true);
        try {
            const response = await Axios({
                method: "get",
                url: `${domain}/api/blog/?page=1`  // Get first page only
            });
            
            // Handle paginated response
            if (response.data && response.data.results) {
                setBlog(response.data.results.slice(0, 3));  // Only take first 3 items for homepage
            } else {
                setBlog([]);
            }
            console.log(response.data, "Blog data");
        } catch (error) {
            console.error("Error fetching blog data:", error);
            setBlog([]);
        } finally {
            setLoading(false);
        }
    }
    
    useEffect(() => {
        getBlog();
    }, []);

    return (
        <>
            <section className="blog-one">
                <div className="container">
                    <div className="section-title text-center">
                        <h2 className="section-title__title">Blog & Media.</h2>
                    </div>
                    
                    {loading ? (
                        <div className="text-center py-3">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : (
                        <div className="row">
                            {Array.isArray(blog) && blog.length > 0 ? (
                                blog.map((blg) => (
                                    <div className="col-xl-4 col-lg-4 wow fadeInUp" data-wow-delay="100ms" key={blg?.id}>
                                        <div className="blog-one__single">
                                            <div className="blog-one__img">
                                                <LazyLoadImage 
                                                    effect="blur" 
                                                    src={`${domain}${blg?.image}`}
                                                    alt={blg?.title_English}
                                                />
                                                <div className="blog-one__date">
                                                    <p>{blg?.date}</p>
                                                </div>
                                                <a href={`/blogdetails${blg?.id}`}>
                                                    <span className="news-one__plus"></span>
                                                </a>
                                            </div>
                                            <div className="blog-one__content">
                                                <ul className="list-unstyled blog-one__meta">
                                                    <li><a href={`/blogdetails${blg?.id}`}><i className="far fa-user-circle"></i> Blog & Media</a></li>
                                                </ul>
                                                <h3 className="blog-one__title">
                                                    <a href={`/blogdetails${blg?.id}`}>{blg?.title_English}</a>
                                                </h3>
                                                <p className="blog-one__text" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(`${blg?.discription_English.slice(0,140)}...`)}} />
                                                <div className="blog-one__bottom">
                                                    <a href={`/blogdetails${blg?.id}`} className="blog-one__btn">Read More</a>
                                                    <a href={`/blogdetails${blg?.id}`} className="blog-one__arrow"><span className="icon-right-arrow"></span></a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="col-12 text-center">
                                    <p>No blog posts available</p>
                                </div>
                            )}
                        </div>
                    )}
                    
                    <div className="text-center mt-4">
                        <a href="/allblog" className="thm-btn">View All Blogs</a>
                    </div>
                </div>
            </section>
        </>
    )
}
